<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" static class="fixed z-20 inset-0 overflow-hidden" @close="$emit('close')" :open="open">
            <div class="absolute inset-0 overflow-hidden" ref="dialog">
                <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <div class="fixed inset-y-0 right-0 pl-2 sm:pl-10 max-w-full flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-300 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-300 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-2xl">
                            <div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">

                                <div class="min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll">
                                    <div class="px-4 sm:px-6">
                                        <div class="flex items-start justify-between">
                                            <DialogTitle class="text-lg font-medium text-gray-900">
                                                {{ __('home::orders.edit_photo') }}
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" @click="$emit('close')">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow relative mt-6 relative px-4 sm:px-6">

                                        <PhotoEditor
                                            :photo="photo"
                                            :order="order"
                                            @saved="onSave"
                                            ref="photoEditor"
                                        />

                                    </div>
                                </div>

                                <!-- Buttons -->
                                <div class="flex-shrink-0 grid grid-cols-3 gap-2 pr-4 py-6 sm:pr-6 pl-20 sm:pl-6 flex justify-between gap-2 border-t border-gray-200">

                                    <button
                                        type="button"
                                        class="flex justify-center items-center py-2 rounded-sm shadow-sm font-medium text-white bg-red-500 hover:bg-red-600 transition-all text-sm sm:text-base"
                                        @click="deletePhoto()"
                                        :disabled="deleting || saving"
                                    >
                                        {{ __('forms::actions.delete') }}
                                        <svg class="animate-spin -mr-1 ml-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="deleting">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </button>

                                    <button
                                        type="button"
                                        class="flex justify-center items-center py-2 rounded-sm shadow-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-all text-sm sm:text-base"
                                        @click="$emit('close')"
                                        :disabled="deleting || saving"
                                    >
                                        {{ __('forms::actions.cancel') }}
                                    </button>

                                    <button
                                        type="button"
                                        class="flex justify-center items-center py-2 rounded-sm shadow-sm font-medium text-white bg-primary hover:bg-primary-light transition-all text-sm sm:text-base"
                                        @click="save"
                                        :disabled="deleting || saving"
                                    >
                                        {{ __('forms::actions.save') }}
                                        <svg class="animate-spin -mr-1 ml-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="saving">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
    import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
    import { XIcon } from '@heroicons/vue/outline'

    export default {
        components: {
            Dialog,
            DialogOverlay,
            DialogTitle,
            TransitionChild,
            TransitionRoot,
            XIcon,
        },
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            photo: Object,
            order: Object,
        },
        data() {
            return {
                deleting: false,
                saving: false,
            };
        },
        methods: {
            save() {
                this.saving = true;
                this.$refs.photoEditor.save();
            },
            onSave(event) {
                this.saving = false;
                this.$emit('update:photo', event);
            },
            deletePhoto() {
                this.deleting = true;
                this.$emit('delete');
            },
        },
    }
</script>
